//  TODO: EXPERIMENTAL FILE. Unsure if this is a good practice. This is starting
// to feel like overkill. Just hardcode the paths?
//
// This file is shared with client/server, to DRY up route declarations.
// My arbitrary classification
// - "path" = string or path-to-regexp string
// - "route" = object that contains path, and
//             functions to convert to/from path-to-regxp
//
// TODO: Move all route declarations to this file, eventually. This file will
// become the source of truth, wrt the url String. Then, client side axios will
// import for the url, and server side express will import for the pathToRegexp.

import { pathToRegexp, match, parse, compile } from 'path-to-regexp'

export class Route {
    constructor (str) {
        this.regexPath = str
        this.matchPath = match(str)
    }
    // Checks if a string like /channels/234542, matches
    // a regexPath like /channels/:channelId
    matches (path) {
        return !!this.matchPath(path)
    }
}

// Most routes are scoped under this base path, in order to check
// jwt.userId === channelId, where necessary.
const channelPath = '/channels/:channelId'
export const channelRoute = new Route(channelPath)

const emotesPath = '/emotes'
export const emotesRoute = new Route(emotesPath)

const suggPath = `${channelPath}/suggestions`
export const suggRoute = new Route(suggPath)

const suggIdPath = `${suggPath}/:suggestionId`
export const suggIdRoute = new Route(suggIdPath)
